import React, { useState } from "react";
import { ReactComponent as BsBoxArrowRight } from "../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import DuePaymentModal from "../Financial/CashOutFlow/AcademicEx/MaterialAndResources/DuePaymentModal.component";

const HistoryTable = ({ historyTableData, setShowHistory }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="history-table">
      <div className="scroll-y" style={{ maxHeight: "340px" }}>
        <table
          style={{
            width: "100%",
            textAlign: "left",
            marginTop: "1rem",
            borderCollapse: "collapse",
            backgroundColor: "white",
          }}
        >
          <thead>
            <tr>
              {[
                "Receipt id/Time",
                "Items",
                "Order size",
                "Amount (INR)",
                "Paid Amount (INR)",
                "Vendor details",
                "Confirmed by",
                "Receipts",
              ].map((heading, i) => (
                <th
                  key={i}
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,
                    color: "var(--grayColor)",
                    paddingBlock: "0.75rem",
                    paddingInline: "1rem",
                    fontWeight: "500",
                    fontSize: "0.875rem",
                    borderBottom: "1px solid var(--grayColor)",
                  }}
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {historyTableData.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.receiptId}
                  <br />
                  <span
                    style={{
                      color: "var(--tableColor)",
                      fontSize: "small",
                    }}
                  >
                    {item.time}
                  </span>
                </td>

                <td>
                  {item.items.map((d, i) => (
                    <div key={i}>{d.name}</div>
                  ))}
                </td>

                <td>
                  {item.items.map((d, i) => (
                    <div key={i}>
                      {d.quantity} {d.unit}
                    </div>
                  ))}
                </td>

                <td>
                  {item.items.map((d, i) => (
                    <div key={i}>
                      ₹ {(d.quantity * d.unitPrice).toLocaleString("en-IN")}
                    </div>
                  ))}
                  <div
                    style={{
                      display: "inline",
                      borderTop: "1px solid black",
                    }}
                  >
                    Total:{" "}
                    <span style={{ color: "var(--blueColor1)" }}>
                      ₹ {item.totalAmount}
                    </span>
                  </div>
                </td>

                <td>
                  ₹ {item.paidAmount}
                  <br />
                  <span
                    style={{
                      color: "var(--deepGreen3)",
                      fontSize: "small",
                    }}
                  >
                    {item.paymentMethod}
                  </span>
                </td>

                <td>
                  {item.vendor.name}
                  <br />
                  ph:{" "}
                  <span style={{ color: "var(--blueColor1)" }}>
                    {item.vendor.phone}
                  </span>
                </td>

                <td style={{ color: "var(--deepGreen3)" }}>
                  {item.confirmedBy}
                </td>

                <td>
                  <span
                    style={{
                      color: "var(--blueColor1)",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowHistory(true)}
                  >
                    Receipt <BsBoxArrowRight />
                  </span>
                  <br />
                  <button
                    style={{
                      backgroundColor:
                        item.paidAmount < item.totalAmount
                          ? "var(--tableColor)"
                          : "var(--deepGreen3)",
                      borderColor:
                        item.paidAmount < item.totalAmount
                          ? "var(--tableColor)"
                          : "var(--deepGreen3)",
                    }}
                    className="action-pay-btn"
                    onClick={() =>
                      item.paidAmount < item.totalAmount && setOpen(true)
                    }
                  >
                    {item.paidAmount < item.totalAmount
                      ? "Pay due"
                      : "All paid"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && <DuePaymentModal onClose={() => setOpen(false)} />}

      {/* Indicators */}
      <div className="Amount-Indicators">
        <div className="indicator-group">
          <span className="indicator-box filled-orange">
            Total count: <span className="text-white">236</span>
          </span>

          <span className="indicator-box outlined-orange">
            Due amount: <span className="text-orange">₹ 2,60,560</span>
          </span>
        </div>

        <div className="indicator-group">
          <span className="indicator-box outlined-blue">
            Total amounts:{" "}
            <span className="text-blue-light">₹ 2,60,560</span>
          </span>

          <span className="indicator-box filled-blue">
            Paid amount: <span className="text-white">₹ 2,60,560</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default HistoryTable;
